import React, { useState, useEffect, useContext } from "react";
import { BarbershopContext } from "../providers/useProvider";
import { resetPassword } from "../api/authService";
import { useNavigate } from "react-router-dom"; // For navigating after login

const useResetPassword = () => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [barbershop, setBarbershop] = useState("");

  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const [error, setError] = useState(null);
  const { config } = useContext(BarbershopContext);
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    setEmail(params.get("email") || "");
    setToken(params.get("token") || "");

    // Extract subdomain → {shop}.kazaslot.be
    const host = window.location.hostname;
    const shop = host.split(".")[0];
    setBarbershop(shop);
  }, []);
  const submitToReset = async (password) => {
    setError(null);
    setMessage(null);

    try {
      setLoading(true);

      const response = await resetPassword(
        email,
        password,
        token,
        config.id,
        barbershop,
      );
      if (response.isSuccess) {
        setMessage({ text: response.value, type: "success" });
        setShowMessage(true);
        // Wait 4 seconds, then call run
        setTimeout(() => navigate(`/login`), 4000);
      } else {
        setMessage({ text: response.errors.join("\n"), type: "danger" });
        setShowMessage(true);

        setTimeout(() => navigate(`/forget-password`), 4000);
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to reset your password. Your link may have expired.",
      );
    } finally {
      setLoading(false);
    }
  };
  return {
    email,
    submitToReset,
    message,
    setShowMessage,
    showMessage,
    config,
    loading,
  };
};
export default useResetPassword;
